{
  "id": "languages",
  "name": "Languages",
  "standard": "ISO 639:2023 (Set 1)",
  "version": "iso-codes 4.20.1",
  "granularity": "All 184 two-letter language codes (formerly ISO 639-1), selected from ISO 639-3; not the full ISO 639 language registry",
  "license": "LGPL-2.1-or-later",
  "licenseUrl": "https://www.gnu.org/licenses/old-licenses/lgpl-2.1.html",
  "attribution": "ISO code data: Copyright 2016 Dr. Tobias Quathamer, iso-codes contributors. Transformed from iso-codes 4.20.1; see NOTICE.md and LICENSES/LGPL-2.1-or-later.txt.",
  "sourceUrl": "https://deb.debian.org/debian/pool/main/i/iso-codes/iso-codes_4.20.1.orig.tar.xz",
  "sourceSha256": "5d551f3ddb32548c4321e9011720fd97751af0107592f79ebffc939bd32f2268",
  "retrievedAt": "2026-09-12",
  "options": [
    {
      "value": "ab",
      "label": "Abkhazian"
    },
    {
      "value": "aa",
      "label": "Afar"
    },
    {
      "value": "af",
      "label": "Afrikaans"
    },
    {
      "value": "ak",
      "label": "Akan"
    },
    {
      "value": "sq",
      "label": "Albanian"
    },
    {
      "value": "am",
      "label": "Amharic"
    },
    {
      "value": "ar",
      "label": "Arabic"
    },
    {
      "value": "an",
      "label": "Aragonese"
    },
    {
      "value": "hy",
      "label": "Armenian"
    },
    {
      "value": "as",
      "label": "Assamese"
    },
    {
      "value": "av",
      "label": "Avaric"
    },
    {
      "value": "ae",
      "label": "Avestan"
    },
    {
      "value": "ay",
      "label": "Aymara"
    },
    {
      "value": "az",
      "label": "Azerbaijani"
    },
    {
      "value": "bm",
      "label": "Bambara"
    },
    {
      "value": "bn",
      "label": "Bangla"
    },
    {
      "value": "ba",
      "label": "Bashkir"
    },
    {
      "value": "eu",
      "label": "Basque"
    },
    {
      "value": "be",
      "label": "Belarusian"
    },
    {
      "value": "bi",
      "label": "Bislama"
    },
    {
      "value": "bs",
      "label": "Bosnian"
    },
    {
      "value": "br",
      "label": "Breton"
    },
    {
      "value": "bg",
      "label": "Bulgarian"
    },
    {
      "value": "my",
      "label": "Burmese"
    },
    {
      "value": "ca",
      "label": "Catalan"
    },
    {
      "value": "ch",
      "label": "Chamorro"
    },
    {
      "value": "ce",
      "label": "Chechen"
    },
    {
      "value": "ny",
      "label": "Chichewa"
    },
    {
      "value": "zh",
      "label": "Chinese"
    },
    {
      "value": "cu",
      "label": "Church Slavic"
    },
    {
      "value": "cv",
      "label": "Chuvash"
    },
    {
      "value": "kw",
      "label": "Cornish"
    },
    {
      "value": "co",
      "label": "Corsican"
    },
    {
      "value": "cr",
      "label": "Cree"
    },
    {
      "value": "hr",
      "label": "Croatian"
    },
    {
      "value": "cs",
      "label": "Czech"
    },
    {
      "value": "da",
      "label": "Danish"
    },
    {
      "value": "dv",
      "label": "Divehi"
    },
    {
      "value": "nl",
      "label": "Dutch"
    },
    {
      "value": "dz",
      "label": "Dzongkha"
    },
    {
      "value": "en",
      "label": "English"
    },
    {
      "value": "eo",
      "label": "Esperanto"
    },
    {
      "value": "et",
      "label": "Estonian"
    },
    {
      "value": "ee",
      "label": "Ewe"
    },
    {
      "value": "fo",
      "label": "Faroese"
    },
    {
      "value": "fj",
      "label": "Fijian"
    },
    {
      "value": "fi",
      "label": "Finnish"
    },
    {
      "value": "fr",
      "label": "French"
    },
    {
      "value": "ff",
      "label": "Fulah"
    },
    {
      "value": "gl",
      "label": "Galician"
    },
    {
      "value": "lg",
      "label": "Ganda"
    },
    {
      "value": "ka",
      "label": "Georgian"
    },
    {
      "value": "de",
      "label": "German"
    },
    {
      "value": "gn",
      "label": "Guarani"
    },
    {
      "value": "gu",
      "label": "Gujarati"
    },
    {
      "value": "ht",
      "label": "Haitian"
    },
    {
      "value": "ha",
      "label": "Hausa"
    },
    {
      "value": "he",
      "label": "Hebrew"
    },
    {
      "value": "hz",
      "label": "Herero"
    },
    {
      "value": "hi",
      "label": "Hindi"
    },
    {
      "value": "ho",
      "label": "Hiri Motu"
    },
    {
      "value": "hu",
      "label": "Hungarian"
    },
    {
      "value": "is",
      "label": "Icelandic"
    },
    {
      "value": "io",
      "label": "Ido"
    },
    {
      "value": "ig",
      "label": "Igbo"
    },
    {
      "value": "id",
      "label": "Indonesian"
    },
    {
      "value": "ia",
      "label": "Interlingua (International Auxiliary Language Association)"
    },
    {
      "value": "ie",
      "label": "Interlingue"
    },
    {
      "value": "iu",
      "label": "Inuktitut"
    },
    {
      "value": "ik",
      "label": "Inupiaq"
    },
    {
      "value": "ga",
      "label": "Irish"
    },
    {
      "value": "it",
      "label": "Italian"
    },
    {
      "value": "ja",
      "label": "Japanese"
    },
    {
      "value": "jv",
      "label": "Javanese"
    },
    {
      "value": "kl",
      "label": "Kalaallisut"
    },
    {
      "value": "kn",
      "label": "Kannada"
    },
    {
      "value": "kr",
      "label": "Kanuri"
    },
    {
      "value": "ks",
      "label": "Kashmiri"
    },
    {
      "value": "kk",
      "label": "Kazakh"
    },
    {
      "value": "km",
      "label": "Khmer"
    },
    {
      "value": "ki",
      "label": "Kikuyu"
    },
    {
      "value": "rw",
      "label": "Kinyarwanda"
    },
    {
      "value": "ky",
      "label": "Kirghiz"
    },
    {
      "value": "kv",
      "label": "Komi"
    },
    {
      "value": "kg",
      "label": "Kongo"
    },
    {
      "value": "ko",
      "label": "Korean"
    },
    {
      "value": "kj",
      "label": "Kuanyama"
    },
    {
      "value": "ku",
      "label": "Kurdish"
    },
    {
      "value": "lo",
      "label": "Lao"
    },
    {
      "value": "la",
      "label": "Latin"
    },
    {
      "value": "lv",
      "label": "Latvian"
    },
    {
      "value": "li",
      "label": "Limburgan"
    },
    {
      "value": "ln",
      "label": "Lingala"
    },
    {
      "value": "lt",
      "label": "Lithuanian"
    },
    {
      "value": "lu",
      "label": "Luba-Katanga"
    },
    {
      "value": "lb",
      "label": "Luxembourgish"
    },
    {
      "value": "mk",
      "label": "Macedonian"
    },
    {
      "value": "mg",
      "label": "Malagasy"
    },
    {
      "value": "ms",
      "label": "Malay (macrolanguage)"
    },
    {
      "value": "ml",
      "label": "Malayalam"
    },
    {
      "value": "mt",
      "label": "Maltese"
    },
    {
      "value": "gv",
      "label": "Manx"
    },
    {
      "value": "mi",
      "label": "Maori"
    },
    {
      "value": "mr",
      "label": "Marathi"
    },
    {
      "value": "mh",
      "label": "Marshallese"
    },
    {
      "value": "el",
      "label": "Modern Greek (1453-)"
    },
    {
      "value": "mn",
      "label": "Mongolian"
    },
    {
      "value": "na",
      "label": "Nauru"
    },
    {
      "value": "nv",
      "label": "Navajo"
    },
    {
      "value": "ng",
      "label": "Ndonga"
    },
    {
      "value": "ne",
      "label": "Nepali (macrolanguage)"
    },
    {
      "value": "nd",
      "label": "North Ndebele"
    },
    {
      "value": "se",
      "label": "Northern Sami"
    },
    {
      "value": "no",
      "label": "Norwegian"
    },
    {
      "value": "nb",
      "label": "Norwegian Bokmål"
    },
    {
      "value": "nn",
      "label": "Norwegian Nynorsk"
    },
    {
      "value": "oc",
      "label": "Occitan (post 1500)"
    },
    {
      "value": "oj",
      "label": "Ojibwa"
    },
    {
      "value": "or",
      "label": "Oriya (macrolanguage)"
    },
    {
      "value": "om",
      "label": "Oromo"
    },
    {
      "value": "os",
      "label": "Ossetian"
    },
    {
      "value": "pi",
      "label": "Pali"
    },
    {
      "value": "pa",
      "label": "Panjabi"
    },
    {
      "value": "fa",
      "label": "Persian"
    },
    {
      "value": "pl",
      "label": "Polish"
    },
    {
      "value": "pt",
      "label": "Portuguese"
    },
    {
      "value": "ps",
      "label": "Pushto"
    },
    {
      "value": "qu",
      "label": "Quechua"
    },
    {
      "value": "ro",
      "label": "Romanian"
    },
    {
      "value": "rm",
      "label": "Romansh"
    },
    {
      "value": "rn",
      "label": "Rundi"
    },
    {
      "value": "ru",
      "label": "Russian"
    },
    {
      "value": "sm",
      "label": "Samoan"
    },
    {
      "value": "sg",
      "label": "Sango"
    },
    {
      "value": "sa",
      "label": "Sanskrit"
    },
    {
      "value": "sc",
      "label": "Sardinian"
    },
    {
      "value": "gd",
      "label": "Scottish Gaelic"
    },
    {
      "value": "sr",
      "label": "Serbian"
    },
    {
      "value": "sh",
      "label": "Serbo-Croatian"
    },
    {
      "value": "sn",
      "label": "Shona"
    },
    {
      "value": "ii",
      "label": "Sichuan Yi"
    },
    {
      "value": "sd",
      "label": "Sindhi"
    },
    {
      "value": "si",
      "label": "Sinhala"
    },
    {
      "value": "sk",
      "label": "Slovak"
    },
    {
      "value": "sl",
      "label": "Slovenian"
    },
    {
      "value": "so",
      "label": "Somali"
    },
    {
      "value": "nr",
      "label": "South Ndebele"
    },
    {
      "value": "st",
      "label": "Southern Sotho"
    },
    {
      "value": "es",
      "label": "Spanish"
    },
    {
      "value": "su",
      "label": "Sundanese"
    },
    {
      "value": "sw",
      "label": "Swahili (macrolanguage)"
    },
    {
      "value": "ss",
      "label": "Swati"
    },
    {
      "value": "sv",
      "label": "Swedish"
    },
    {
      "value": "tl",
      "label": "Tagalog"
    },
    {
      "value": "ty",
      "label": "Tahitian"
    },
    {
      "value": "tg",
      "label": "Tajik"
    },
    {
      "value": "ta",
      "label": "Tamil"
    },
    {
      "value": "tt",
      "label": "Tatar"
    },
    {
      "value": "te",
      "label": "Telugu"
    },
    {
      "value": "th",
      "label": "Thai"
    },
    {
      "value": "bo",
      "label": "Tibetan"
    },
    {
      "value": "ti",
      "label": "Tigrinya"
    },
    {
      "value": "to",
      "label": "Tonga (Tonga Islands)"
    },
    {
      "value": "ts",
      "label": "Tsonga"
    },
    {
      "value": "tn",
      "label": "Tswana"
    },
    {
      "value": "tr",
      "label": "Turkish"
    },
    {
      "value": "tk",
      "label": "Turkmen"
    },
    {
      "value": "tw",
      "label": "Twi"
    },
    {
      "value": "ug",
      "label": "Uighur"
    },
    {
      "value": "uk",
      "label": "Ukrainian"
    },
    {
      "value": "ur",
      "label": "Urdu"
    },
    {
      "value": "uz",
      "label": "Uzbek"
    },
    {
      "value": "ve",
      "label": "Venda"
    },
    {
      "value": "vi",
      "label": "Vietnamese"
    },
    {
      "value": "vo",
      "label": "Volapük"
    },
    {
      "value": "wa",
      "label": "Walloon"
    },
    {
      "value": "cy",
      "label": "Welsh"
    },
    {
      "value": "fy",
      "label": "Western Frisian"
    },
    {
      "value": "wo",
      "label": "Wolof"
    },
    {
      "value": "xh",
      "label": "Xhosa"
    },
    {
      "value": "yi",
      "label": "Yiddish"
    },
    {
      "value": "yo",
      "label": "Yoruba"
    },
    {
      "value": "za",
      "label": "Zhuang"
    },
    {
      "value": "zu",
      "label": "Zulu"
    }
  ]
}
